/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import axios, { AxiosError } from 'axios';

import { BASE_API_URL, FEDERATION_API_URL, NOTIFICATION_API_URL } from '@/shared/constant/api';
import { getSession } from '@/shared/helpers/utils';

import { resetAuth } from '@/utils/resetAuth';

export const api = axios.create({
	baseURL: BASE_API_URL,
	headers: {
		'Content-Type': 'application/json',
	},
	// withCredentials: true,
});

export const federationApi = axios.create({
	baseURL: FEDERATION_API_URL,
	headers: {
		'Content-Type': 'application/json',
	},
});

export const notificationApi = axios.create({
	baseURL: NOTIFICATION_API_URL,
	headers: {
		'Content-Type': 'application/json',
	},
});

api.interceptors.request.use((config) => {
	const url = window.location.origin;
	const token = getSession()?.access_token;

	config.headers['X-Phs-From-User-Url'] = url;

	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}

	return config;
});

api.interceptors.response.use(
	(response) => {
		return response;
	},
	(error: AxiosError) => {
		switch (error?.response?.status) {
			case 401:
				// notify('Ошибка авторизации');
				setTimeout(resetAuth, 2000);
				break;

			// case 500:
			// 	notify('Ошибка клиент-серверного взаимодействия');
			// 	break;
		}

		return Promise.reject(error);
	},
);

federationApi.interceptors.request.use((config) => {
	const url = window.location.origin;

	config.headers['X-Phs-From-User-Url'] = url;

	return config;
});

notificationApi.interceptors.request.use((config) => {
	const url = window.location.origin;
	const token = getSession()?.access_token;

	config.headers['X-Phs-From-User-Url'] = url;

	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}

	return config;
});
